const mutations = {
  saveUserInSession(state) {
    sessionStorage.setItem('user_data', JSON.stringify(state.userData) )
  },
  setCountriesArr(state, payload) {
    state.countriesArr = payload.countriesArr;
  },
  setUserAuth(state, payload) {
    state.userAuthenticated = payload.userAuthenticated
  },
  setActiveStep(state, payload) {
    state.activeStep = payload.activeStep;
    sessionStorage.setItem('activeSubscriptionStep', payload.activeStep);
    setTimeout(() => {window.scrollTo(0,0)}, 500 );
  },
  setUserData(state, payload) {
    state.userData = payload.userData;
  },
  setUserName(state, payload) {
    state.userData.name = payload.name
  },
  setUserEmail(state, payload) {
    state.userData.email = payload.email
  },
  setCouponPlan(state, payload) {
    state.couponPlan = payload.couponPlan;
  },
  setCouponCode(state, payload) {
    state.couponCode = payload.code;
    if (payload.code !== '') sessionStorage.setItem('couponCode', payload.code);
  },
  setSelectedPlan(state, payload) {
    state.selectedPlan = payload.selectedPlan;
    sessionStorage.setItem('selectedPlan', JSON.stringify(payload.selectedPlan));
  },
  setDeliveryMethod(state, payload) {
    state.deliveryMethod = payload.deliveryMethod;
  },
  setPaymentMethod(state, payload) {
    state.paymentMethod = payload.paymentMethod;
  },
  // Delivery address setters
  setEmptyAddress(state) {
    state.userData.address = {
      firstname: '',
      lastname: '',
      company: '',
      phone: '',
      street: '',
      streetnumber: '',
      apartamentnumber: '',
      postcode: '',
      city: '',
      country: ''
    }
  },
  setFirstName(state, payload) {
    state.userData.address.firstname = payload.deliveryFirstName;
  },
  setLastName(state, payload) {
    state.userData.address.lastname = payload.deliveryLastName;
  },
  setCompanyName(state, payload) {
    state.userData.address.company = payload.deliveryCompanyName;
  },
  setPhoneNumber(state, payload) {
    state.userData.address.phone = payload.deliveryPhoneNumber;
  },
  setStreet(state, payload) {
    state.userData.address.street = payload.deliveryStreet;
  },
  setStreetNumber(state, payload) {
    state.userData.address.streetnumber = payload.deliveryStreetNumber;
  },
  setApartmentNumber(state, payload) {
    state.userData.address.apartamentnumber = payload.deliveryApartmentNumber;
  },
  setZipCode(state, payload) {
    state.userData.address.postcode = payload.deliveryZipCode;
  },
  setCity(state, payload) {
    state.userData.address.city = payload.deliveryCity;
  },
  setCountry(state, payload) {
    if (payload.deliveryCountry === null) {
      state.userData.address.country = 'Polska';
    } else {
      state.userData.address.country = payload.deliveryCountry;
    }
  },
  // Invoice setters
  setEmptyInvoice(state) {
    state.userData.invoice = {
      company: '',
      nip: '',
      street: '',
      streetnumber: '',
      apartamentnumber: '',
      postcode: '',
      city: '',
      country: ''
    }
  },
  setInvoiceCompanyName(state, payload) {
    state.userData.invoice.company = payload.invoiceCompanyName;
  },
  setInvoiceTaxID(state, payload) {
    state.userData.invoice.nip = payload.invoiceTaxID;
  },
  setInvoiceStreet(state, payload) {
    state.userData.invoice.street = payload.invoiceStreet;
  },
  setInvoiceStreetNumber(state, payload) {
    state.userData.invoice.streetnumber = payload.invoiceStreetNumber;
  },
  setInvoiceApartmentNumber(state, payload) {
    state.userData.invoice.apartamentnumber = payload.invoiceApartmentNumber;
  },
  setInvoiceZipCode(state, payload) {
    state.userData.invoice.postcode = payload.invoiceZipCode;
  },
  setInvoiceCity(state, payload) {
    state.userData.invoice.city = payload.invoiceCity;
  },
  setInvoiceCountry(state, payload) {
    state.userData.invoice.country = payload.invoiceCountry;
  },
  // Gift setters
  saveGiftInSession(state) {
    sessionStorage.setItem('gift_data', JSON.stringify(state.giftData));
  },
  setGiftStatus(state, payload) {
    state.giftData.isGift = payload.isGift;
  },
  setGiftDeliveryMethod(state, payload) {
    state.giftData.deliveryMethod = payload.giftDeliveryMethod;
  },
  setGiftRecipientName(state, payload) {
    state.giftData.name = payload.giftRecipientName;
  },
  setGiftRecipientEmail(state, payload) {
    state.giftData.email = payload.giftRecipientEmail;
  },
  setGiftRecipientMsg(state, payload) {
    state.giftData.message = payload.giftRecipientMsg;
  },

  SET_DIGITAL_PLANS(state, payload) {

  }
};
export default mutations;
